<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-19 14:35:50
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-19 14:36:02
-->
<template>
    <router-view />
</template>

<script>
export default {
	name: 'Insure',
};
</script>